import { render, staticRenderFns } from "./SlevaInputNumer.vue?vue&type=template&id=683aaddf&scoped=true&"
import script from "./SlevaInputNumer.vue?vue&type=script&lang=ts&"
export * from "./SlevaInputNumer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683aaddf",
  null
  
)

export default component.exports